import React, { useState, useEffect, useRef } from 'react';
import { Doughnut } from 'react-chartjs-2';
import 'chartjs-adapter-moment';

const Usage = () => {
  const [data, setData] = useState([]);
  const [csvUsageData, setCsvUsageData] = useState([]);
  const [electricityUsage, setElectricityUsage] = useState('');
  const [dateUsage, setDateUsage] = useState('');
  const [department, setDepartment] = useState('');
  const [gasUsage, setGasUsage] = useState('');
  const [hasElectricityUsageError, setHasElectricityUsageError] =
    useState(true);
  const [hasGasUsageError, setHasGasUsageError] = useState(true);
  const [showError, setShowError] = useState(false);
  const csvRef = useRef(null);

  useEffect(() => {
    const dayElem = document.getElementById('day');
    const monthElem = document.getElementById('month');
    const yearElem = document.getElementById('year');

    const handleScopeChange = (newScope) => {
      monthElem.classList.toggle('active', newScope === 'month');
      yearElem.classList.toggle('active', newScope === 'year');
      dayElem.classList.toggle('active', newScope === 'day');
    };

    monthElem.addEventListener('click', () => handleScopeChange('month'));
    yearElem.addEventListener('click', () => handleScopeChange('year'));
    dayElem.addEventListener('click', () => handleScopeChange('day'));

    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch('https://fusionsmart.seifeddineslimene.com/api/getUsage', {
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
        },
      });
      const csvData = await response.json();
      setCsvUsageData(csvData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const chartData = {
    labels: csvUsageData
      ? csvUsageData.map((entry) =>
          new Date(entry.dateUsage).toLocaleDateString()
        )
      : data.map((entry) => new Date(entry.dateUsage).toLocaleDateString()),
    datasets: [
      {
        label: 'electricity Usage',
        data: csvUsageData
          ? csvUsageData.map((entry) => entry.electricityUsage)
          : data.map((entry) => entry.electricityUsage),
        backgroundColor: 'rgba(0, 0, 0, 1)',
        borderColor: 'rgba(0, 0, 0, 1)',
      },
      {
        label: 'Gas Usage',
        data: csvUsageData
          ? csvUsageData.map((entry) => entry.gasUsage)
          : data.map((entry) => entry.gasUsage),
        backgroundColor: 'rgba(0, 255, 0, 0.5)',
        borderColor: 'rgba(0, 255, 0, 0.5)',
      },
    ],
  };

  const deleteCsv = async (e) => {
    e.preventDefault();
    try {
      setShowError(false);
      await fetch('https://fusionsmart.seifeddineslimene.com/api/deleteAllCsvUsageData', {
        method: 'DELETE',
      });
      setCsvUsageData([]);
    } catch (error) {
      console.error(error);
    }
  };

  const UsageData = async (event) => {
    event.preventDefault();
    if (hasElectricityUsageError || hasGasUsageError) {
      setShowError(true);
    } else {
      try {
        setShowError(false);
        await fetch('https://fusionsmart.seifeddineslimene.com/api/Usage', {
          method: 'POST',
          headers: {
            'Content-type': 'application/json',
          },
          body: JSON.stringify({
            electricityUsage: electricityUsage + '$',
            gasUsage: gasUsage + '$',
            department,
          }),
        });
        setData([
          ...data,
          { date: new Date(), electricityUsage, gasUsage, department },
        ]);
      } catch (error) {
        console.error(error);
      }
    }
  };

  const CSVSubmit = async (e) => {
    e.preventDefault();
    let upload = await uploadFile();
    if (upload.error === 0) {
      setCsvUsageData(upload.usageCsvData);
    } else if (upload.error === 1) {
      alert('File uploading failed - ' + upload.message);
    }
  };

  const uploadFile = async () => {
    let return_data;
    try {
      if (csvRef.current.files.length === 0) {
        throw new Error('No file selected');
      } else {
        let data = new FormData();
        data.append('csvFile', csvRef.current.files[0]);
        const response = await fetch('https://fusionsmart.seifeddineslimene.com/api/uploadUsage', {
          method: 'POST',
          body: data,
        });
        if (response.status !== 200) {
          throw new Error('HTTP response code !== 200');
        }
        return_data = await response.json();
        if (return_data.error === 1) throw new Error(return_data.message);
      }
    } catch (error) {
      return_data = { error: 1, message: error.message };
    }
    return return_data;
  };

 /* const options = {
    scales: {
      x: {
        type: 'time', // Use time scale for x-axis
        time: {
          unit: 'month',
          displayFormats: {
            month: 'mm',
          },
        },
      },
      y: {
        beginAtZero: true,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
      },
      title: {
        display: true,
        text: 'Usage chart',
      },
    },
  };
*/
  const handleChangeData = (e) => {
    if (e.target.name === 'electricityUsage') {
      setShowError(false);
      if (e.target.value.length === 0 || isNaN(parseInt(e.target.value))) {
        setHasElectricityUsageError(true);
        setGasUsage(e.target.value);
      } else {
        setHasElectricityUsageError(false);
        setGasUsage(e.target.value);
      }
    } else {
      setShowError(false);
      if (e.target.value.length === 0 || isNaN(parseInt(e.target.value))) {
        setHasGasUsageError(true);
        setGasUsage(e.target.value);
      } else {
        setHasGasUsageError(false);
        setGasUsage(e.target.value);
      }
    }
  };

  const resetForm = (e) => {
    e.preventDefault();
    setShowError(false);
    setHasElectricityUsageError(true);
    setHasGasUsageError(true);
    setElectricityUsage('');
    setGasUsage('');
    setDepartment('');
  };

  return (
    <div
      id='content-body'
      className='col-12 col-md-9 col-xl-10 pl-4 pr-4 bd-content'
    >
      <div className='mb-8 pt-4 mt-3' style={{ height: '60px' }}>
        <div className='col-md-12 pt-4'>
          <h2>Usage By Department</h2>
        </div>
      </div>
      <div className='mb-5'>
        <form
          onSubmit={UsageData}
          className='mt-5 mb-3 d-flex justify-content-center align-items-center'
        >
          <div className='me-2'>
            <span className='d-inline-block me-2'>Electricity Usage</span>
            <input
              value={electricityUsage}
              onChange={handleChangeData}
              placeholder='electricityUsage'
              type='text'
            />
          </div>
          <div className='me-2'>
            <span className='d-inline-block me-2'>Greenas Usage</span>
            <input
              value={gasUsage}
              onChange={handleChangeData}
              placeholder='gasUsage'
              type='text'
            />
          </div>
          <div className='me-2'>
            <span className='d-inline-block me-2'>Date</span>
            <input
              value={dateUsage}
              onChange={(e) => setDateUsage(e.target.value)}
              placeholder='Date'
              type='Date'
            />
          </div>

          <div className='me-2'>
            <button type='submit' className='me-2'>
              Envoyer
            </button>
            <button onClick={resetForm}>Vider Les Champs</button>
            {showError && (
              <p className='text-center text-danger fw-bold'>
                *Renseigner tous les champs avant de valider, tous les champs
                doivent être des nombres!
              </p>
            )}
          </div>
        </form>
      </div>
      <div className='mb-5'>
        <form
          onSubmit={CSVSubmit}
          className='mt-5 mb-3 d-flex justify-content-center align-items-center'
        >
          <div className='me-2'>
            <span className='d-inline-block me-1'>CSV</span>
            <input
              ref={csvRef}
              id='usage-csv'
              accept='text/csv'
              type='file'
              name='usage-csv'
            />
          </div>
          <button type='submit' className='me-2'>
            Envoyer CSV
          </button>
          <button className='me-2' onClick={deleteCsv}>
            Delete CSV
          </button>
        </form>
      </div>
      <div className='mb-5 text-center'>
        <ul className='buttonwrapper'>
          <li id='day' className='active'>
            <label id='l1'>DAY</label>
          </li>
          <li id='month'>
            <label id='l2'>MONTH</label>
          </li>
          <li id='year'>
            <label id='l3'>YEAR</label>
          </li>
        </ul>
      </div>
      <h1>CSV Line Chart</h1>
      <div className='chart-card mb-5'>
        {(data.length > 0 || csvUsageData.length > 0) && (
          <Doughnut data={chartData}  />
        )}
      </div>
      <div className='row'>
        <div className='col-md-12 pb-3'>
          <span className='footer-text-1'>Energy Tip: </span>
          <span className='footer-text-2'>
            On all days, turning off or unplugging electrical devices when
            you're not at departments can help reduce your energy costs by
            approximately 10 percent.
          </span>
        </div>
      </div>
    </div>
  );
};

export default Usage;
